import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';
import { t, number } from '~/helpers';
import { formatISO } from '~/helpers/dateTime';
import { handleExportGeneric } from '~/helpers/exportReports';
import {
  deleteOperacaoMedicaoTemperatura,
  findOperacaoMedicaoTemperatura,
  recordFiltering,
} from '~/store/modules/operacaomedicaotemperatura/actions';

import FormMedicaoTemperatura from './form';

function OperacaoMedicaoTemperaturaList() {
  const redux = useSelector((state) => state.operacaomedicaotemperatura);
  const { internounidatausuario } = useSelector((state) => state.user.configs);
  const header = useMemo(
    () => [
      {
        id: 'nomeabreviadoposto',
        label: t('s.operacao.medicaotemperatura.nomeabreviadoposto'),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'idtanquevirtual',
        label: t('s.operacao.medicaotemperatura.idtanquevirtual'),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'codigotanquefisico',
        label: t('s.operacao.medicaotemperatura.codigotanquefisico'),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'datahorainiciomedicaotemperatura',
        label: t('s.operacao.medicaotemperatura.datahorainicio'),
        formatted: (date) => formatISO({ date }),
      },

      {
        id: 'temperaturamediamedicaotemperatura',
        label: t('s.operacao.medicaotemperatura.temperaturamedia'),
        align: 'right',
        formatted: (value) => number(value, 1),
      },
    ],
    []
  );

  const actions = useMemo(() => [], [internounidatausuario]);

  const fieldlist = [
    'nomeabreviadoposto',
    'idtanquevirtual',
    'codigotanquefisico',
    'datahorainiciomedicaotemperatura',
    'temperaturamediamedicaotemperatura',
  ];

  const substituirHeader = {
    nomeabreviadoposto: t('s.operacao.medicaotemperatura.nomeabreviadoposto'),
    idtanquevirtual: t('s.operacao.medicaotemperatura.idtanquevirtual'),
    codigotanquefisico: t('s.operacao.medicaotemperatura.codigotanquefisico'),
    datahorainiciomedicaotemperatura: t(
      's.operacao.medicaotemperatura.datahorainicio'
    ),
    temperaturamediamedicaotemperatura: t(
      's.operacao.medicaotemperatura.temperaturamedia'
    ),
  };

  return (
    <UnidataTable
      fixed
      redux={redux}
      header={header}
      read={recordFiltering}
      find={findOperacaoMedicaoTemperatura}
      delete={false}
      remove={deleteOperacaoMedicaoTemperatura}
      form={FormMedicaoTemperatura}
      actions={actions}
      detach="idmedicaotemperatura"
      keys={['idmedicaotemperatura']}
      excel
      pdf
      onExport={(formato) =>
        handleExportGeneric({
          endpoint: 'medicaotemperaturas',
          formato,
          fields: fieldlist,
          headers: substituirHeader,
          redux,
          ordination: redux.params.ordination,
          orderfield: redux.params.orderfield,
          title: 'Relatório de Medição de Temperatura',
          ignorarFormatacao: {
            temperaturamediamedicaotemperatura: true,
          },
        })
      }
    />
  );
}

export default OperacaoMedicaoTemperaturaList;
